//* Vue Route
import type { LocationQueryValue } from "vue-router";

//* 路由参数格式化（仅取第一个数据）
export const query = (data?: LocationQueryValue | LocationQueryValue[]) => {
    if (!data) return "";
    else if (!Array.isArray(data)) return data;
    else {
        return data.find((value) => value) || "";
    }
};

//* 路由参数列表格式化（将数据转成数组）
export const querys = (data?: LocationQueryValue | LocationQueryValue[]) => {
    if (!data) return [];
    else if (!Array.isArray(data)) return [data];
    else {
        return data.filter((value) => value) as string[];
    }
};
